<template>
  <div>
    <LeftListMember :pos="2"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li">
            <router-link to="/info-center" class="txt">我的信息</router-link>
          </li>
          <li class="li">
            <router-link to="/center-password" class="txt">修改密码</router-link>
          </li>
          <li class="li on">
            <router-link to="/center-qualifications" class="txt">资质认证</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="m-infobox4">
            <div class="g-titin1 g-titin2">
              <div class="tit">资质认证</div>
              <div v-if="form.status===0" class="span span1">未认证</div>
              <div v-else-if="form.status===1" class="span">审核中</div>
              <div v-else-if="form.status===2" class="span">已认证</div>
            </div>
            <div class="tips">
              <div class="p">
                提示：提交相关资质认证申请后，布克云平台将审核主体真实性。在认证时须遵守《布克云用户协议》
                和 《布克云隐私政策》相关协议及相关法律。
              </div>
            </div>
            <form action="" onsubmit="return false">
              <div class="group group2">
                <div class="tit1">机构资质信息</div>
                <div class="inner">
                  <div class="txt">机构类型：</div>
                  <div class="rightbox">{{ userTypeText }}</div>
<!--                  <div class="rightbox selbox">-->
<!--                    <el-select-->
<!--                      v-model="form.type"-->
<!--                      placeholder="机构类型"-->
<!--                    >-->
<!--                      <el-option v-for="item in companyTypeList" :key="item.id" :label="item.title" :value="item.id"></el-option>-->
<!--                    </el-select>-->
                    <!-- <select name="" id="">
                      <option value="1">请选择机构类型</option>
                      <option value="2">请选择机构类型2</option>
                      <option value="3">请选择机构类型3</option>
                    </select> -->
                    <!-- <img src="@/assets/images/arr1.png" class="icon" alt="" /> -->
<!--                  </div>-->
                </div>
              </div>
              <div class="group group2 group3">
                <div class="inner inner1">
                  <div class="txt">机构全称</div>
                  <div class="rightbox">{{ form.name }}</div>
                </div>
                <div class="inner">
                  <div class="txt"><span style="position: absolute;left: -10px;color:red;">*</span>统一社会信用代码</div>
                  <div class="rightbox inpbox">
                    <el-input class="inpt" v-model="form.registerNo"></el-input>
                  </div>
                </div>
                <div class="inner inner3">
                  <div class="p">
                    务必与营业执照上的注册号或统一社会信用代码一致
                  </div>
                </div>
              </div>
              <div class="group group2">
                <div class="inner inner2">
                  <div class="txt"><span style="position: absolute;left: -10px;color:red;">*</span>机构资质</div>
                  <div class="rightbox">
                    <div class="p">
                      请上传最新的营业执照、法人证书、组织机构代码证等证件类型。
                    </div>
                    <div class="p">
                      格式要求：原件照片、扫描件或者加盖公章的复印件，支持.jpg
                      .jpeg .bmp .gif .png格式照片，大小不超过10M。
                    </div>
                  </div>
                </div>
                <div class="inner inner3" style="flex-direction: column; align-items: flex-start;position: relative;">
                  <div style="position: relative;">
                    <el-image v-if="form.businessCardImg" :src="form.businessCardImg" :preview-src-list="[form.businessCardImg]" style="width: 200px;height: 200px;" fit="contain"></el-image>
                    <i class="el-icon-circle-close" v-if="form.businessCardImg" style="position: absolute; top: 10px; right: 0px; font-size: 20px; cursor: pointer;" @click.stop="form.businessCardImg=''"></i>
                  </div>
                  <div class="g-upbtn">
                    <pic-upload v-model="form.businessCardImg" :show-file-list="false" list-type="text">
                      <div class="span">上传文件</div>
                    </pic-upload>
                  </div>
                </div>
              </div>
<!--              <div class="group group2 group3">-->
<!--                <div class="inner"></div>-->
<!--                <div class="inner inner3">-->
<!--                  <div class="tips">-->
<!--                    <el-checkbox-group v-model="agreement" style="display: inline-block;">-->
<!--                      <el-checkbox label="" name="agreement"></el-checkbox>-->
<!--                    </el-checkbox-group>-->
<!--                    <div class="p" style="display: inline-block;">-->
<!--                      请先认真阅读-->
<!--                      <a href="/home/index/protocol/type/bk_copyright_promise.html" target="_blank" class="a" style="color: red;">《版权承诺书》</a>-->
<!--                      后勾选，勾选即代表同意并遵守相关协议。-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
              <button class="g-btnsave" v-loading="saving" @click="save">提交</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftListMember from "@/components/LeftListMember";
import getApiData from "@/api/apiUtil";
import apiBkCompanyType from "@/api/bkCompanyType";
import apiBkCompany from "@/api/bkCompany";
import PicUpload from "@/views/common/PicUpload.vue";
export default {
  components: {
    PicUpload,
    LeftListMember,
  },
  data() {
    return {
      form: {
        id: 0,
        uid: 0,
        status: 0,
        type: undefined,
        name: '',
        businessCardImg: '',
        registerNo: ''
      },
      companyTypeList: [],
      agreement: [],
      saving: false,
    };
  },
  computed: {
    userTypeText(){
      switch (this.$store.state.user.userInfo.type){
        case 0: return '企业会员'
        case 1: return '供应商'
        case 2: return '选书会员'
      }
    },
  },
  mounted() {
    // this.loadType()
    this.load()
  },
  methods: {
    async load(){
      let form = await getApiData(apiBkCompany.getInfo(), 0,1)
      Object.assign(this.form, form)
      this.$store.dispatch('user/updateCompany', form)
      if(!this.form.name) this.form.name = this.$store.state.user.userInfo.companyName
      if(!this.form.type) this.form.type = undefined
    },
    async loadType(){
      this.companyTypeList = await getApiData(apiBkCompanyType.getList())
    },
    async save(){
      if(this.saving) return
      // if(this.agreement.length===0) return this.$message.error('请阅读并同意《版权承诺书》')
      if(!this.form.registerNo) return this.$message.error('请输入统一社会信用代码')
      if(!this.form.businessCardImg) return this.$message.error('请上传机构资质')
      this.saving = true
      let form = await getApiData(apiBkCompany.save(this.form),0,1,1,1)
      Object.assign(this.form, form)
      this.saving = false
    }
  },
};
</script>

<style lang="scss" scoped></style>
